import { Modal, ModalBody, ModalContent } from '@heroui/react';
import { useTranslations } from 'next-intl';
import React from 'react';

type EegDataSuccessProps = {
  isOpen: boolean;
  onClose: () => void;
};
export default function EegDataSuccess({
  isOpen,
  onClose,
}: EegDataSuccessProps) {
  const t = useTranslations('eegData.success');

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      classNames={{ closeButton: 'custom-close-button' }}
    >
      <ModalContent className="py-[56px] px-12 text-center">
        <ModalBody>
          <p className="font-medium leading-6.5 md:leading-8.5 text-xl md:text-2xl">
            {t('title')}
          </p>
          <p className="pt-3 pb-8 md:pb-6">{t('info')}</p>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
